export const chartObj = [
    { title : "Lubricant Data", field : [ "Viscosity @ 40°C","Viscosity @ 100°C", "Viscosity Index", "Oxidation", "Flash Point", "Acid Number", "Base Number" ] },
    { title : "Contaminant", field : [ "Vanadium", "Sodium", "Silicon", "Potassium", "Soot Content", "Water By Karl Fischer","Water Content" ] },
    { title : "Wear", field : [ "Aluminium", "Iron", "Nickel", "Lead", "Chromium", "Copper", "Tin", "Molybdenum", "PQ Index", "Silver", "Titanium"]},
    { title : "Additives", field : [ "Calcium", "Magnesium", "Zinc", "Phosphorus", "Manganese", "Antimony", "Boron", "Lithium", "Barium", "Catfines" ] },
    { title : "ISO 4406", field : [ ">4 micron(c)", ">6 micron(c)", ">14 micron(c)"] },
   
]
export const values={
    'Viscosity @ 40°C': false, 'Viscosity @ 100°C': false,
    'Viscosity Index': false, 'Oxidation': false,
    'Flash Point': false, 'Acid Number': false,
    'Base Number': false, 'Vanadium': false,
    'Sodium': false, 'Silicon': false,
    'Potassium': false, 'Soot Content': false,
    'Water By Karl Fischer': false,'Water Content': false ,'Aluminium': false,
    'Iron': false, 'Nickel': false,
    'Lead': false, 'Chromium': false,
    'Copper': false, 'Tin': false, 'Molybdenum': false,
    'PQIndex': false, 'Silver': false, 'Titanium': false,
    'Calcium': false, 'Magnesium': false, 'Zinc': false,
    'Phosphorus': false, 'Cadmium': false, 'Manganese': false,
    'Antimony': false, 'Boron': false, 'Lithium': false,
    'Barium': false, '>4 micron(c)': false,
    '>6 micron(c)': false, '>14 micron(c)': false,
  }
export const months=[ "Jan",
"Feb",
"Mar",
"Apr",
"May",
"Jun",
"Jul",
"Aug",
"Sep",
"Oct",
"Nov",
"Dec"]

